import { render } from "./EditNumberInput.vue?vue&type=template&id=560a4d05&scoped=true"
import script from "./EditNumberInput.vue?vue&type=script&lang=js"
export * from "./EditNumberInput.vue?vue&type=script&lang=js"

import "./EditNumberInput.vue?vue&type=style&index=0&id=560a4d05&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560a4d05"]])

export default __exports__